// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// ✅ This is what makes Android show “Install app”
serviceWorkerRegistration.register();
